module.exports = __webpack_public_path__ + "static/img/y2.995c4946.jpg";